<div class="jumbotron jumbotron-fluid">
  <div class="container">
    <h1 class="display-4">Hello Admin EquinEdge!</h1>
    <p class="lead">You can change settings <a [href]="site" target="_blank">{{site}}</a></p>
  </div>
</div>
